import { render, staticRenderFns } from "./ManagerQuotasRegistry.vue?vue&type=template&id=1fdfdff8&lang=pug&"
import script from "./ManagerQuotasRegistry.vue?vue&type=script&lang=js&"
export * from "./ManagerQuotasRegistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports